import { useInView } from '../../hooks/useInView';

export default function FeatureDetails({ tool }) {
  const [ref, inView] = useInView(0.1);

  return (
    <section className="py-20 sm:py-28 bg-white">
      <div className="max-w-4xl mx-auto px-5 sm:px-8">
        <div
          ref={ref}
          className="rounded-3xl overflow-hidden"
          style={{
            opacity: inView ? 1 : 0,
            transform: inView ? 'translateY(0)' : 'translateY(24px)',
            transition: 'opacity 0.6s ease, transform 0.6s ease',
          }}
        >
          <div className="grid md:grid-cols-2 gap-0">
            {/* Left — text */}
            <div className="bg-slate-50 border border-slate-100 rounded-3xl md:rounded-r-none p-10 flex flex-col justify-center">
              <span className="inline-block mb-4 text-xs font-bold tracking-widest uppercase text-brand-blue">
                About This Tool
              </span>
              <h2 className="text-2xl sm:text-3xl font-extrabold text-slate-900 mb-4 tracking-tight">
                {tool.h1}
              </h2>
              <p className="text-slate-600 leading-relaxed">{tool.featureDetails}</p>
            </div>

            {/* Right — gradient panel */}
            <div className="relative bg-hero-gradient rounded-3xl md:rounded-l-none p-10 flex flex-col justify-center overflow-hidden">
              <div className="absolute -top-12 -right-12 w-48 h-48 rounded-full bg-brand-blue opacity-20 blur-3xl" />
              <div className="absolute -bottom-12 -left-12 w-48 h-48 rounded-full bg-brand-indigo opacity-25 blur-3xl" />
              <div className="relative z-10 space-y-4">
                {tool.steps.map((step) => (
                  <div key={step.step} className="flex items-start gap-3">
                    <span className="flex-shrink-0 w-7 h-7 rounded-full bg-white/15 border border-white/20 flex items-center justify-center text-white text-xs font-bold">
                      {step.step}
                    </span>
                    <div>
                      <p className="text-white font-semibold text-sm">{step.title}</p>
                      <p className="text-white/60 text-xs leading-relaxed">{step.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
